import {applicationHistory} from './application-history';
import {setRemoteLoading, userSubscriptionExpired} from "../settings/actions/application-actions";
import {store} from "../App";

export const authorizedRequest = async (uri, body = null, method = 'GET', ignoreLoggedOut = false, showLoadingIcon = true) => {
    let token = checkForTokenOrRedirect(ignoreLoggedOut);
    const requestArguments = {
        method: method,
        credentials: 'same-origin',
        headers: {}
    };
    if (token) {
        requestArguments.headers.Authorization = `Bearer ${token}`;
    }

    if (method.toUpperCase() !== 'GET' && body) {
        requestArguments.body = JSON.stringify(body);
        requestArguments.headers['Content-Type'] = 'application/json';
    }
    networkRequestLog(uri, method, requestArguments);

    return new Promise((resolve, reject) => {
        if (showLoadingIcon) {
            store.dispatch(setRemoteLoading(true));
        }
        fetch(uri, requestArguments)
            .then(response => {
                if (showLoadingIcon) {
                    store.dispatch(setRemoteLoading(false));
                }
                checkResponseStatus(response, ignoreLoggedOut);
                if (response.status === 204 || response.status === 202) {
                    return resolve();
                }
                try {
                    response
                        .json()
                        .then(data => {
                            networkResponseLog(uri, method, data, response.status);
                            resolve(data);
                        })
                        .catch(ex => {
                            networkResponseLog(uri, method, response.statusText, response.status, ex);
                            reject(ex);
                        });
                }catch(e){
                    networkResponseLog(uri, method, response.statusText, response.status, e);
                    reject(ex);
                }
            })
            .catch(ex => {
                store.dispatch(setRemoteLoading(false));
                networkResponseLog(uri, method, ex, ex, ex);
                //Send official rejection to listener
                reject(ex);
            });
    });
};

export const request = async (uri, body = null, method = 'GET') => {
    const requestArguments = {
        method: method,
        headers: {}
    };

    if (method.toUpperCase() !== 'GET' && body) {
        requestArguments.body = JSON.stringify(body);
        requestArguments.headers['Content-Type'] = 'application/json';
    }

    return new Promise((resolve, reject) => {
        store.dispatch(setRemoteLoading(true));
        return fetch(uri, requestArguments)
            .then(response => {
                store.dispatch(setRemoteLoading(false));
                checkResponseStatus(response);
                if (response.status === 204) {
                    return response.status;
                }

                const contentType = response.headers.get("Content-Type") && response.headers.get("Content-Type").toLowerCase();
                if (contentType.includes('application/json')) {
                    return response.json();
                } else if (contentType.includes('text/plain')) {
                    return response.blob();
                } else {
                    return response.status;
                }
            })
            .then(data => {
                if (data.error) {
                    throw data.error;
                }
                networkResponseLog(uri, method, data, data.status);
                resolve(data);
            })
            .catch(ex => {
                store.dispatch(setRemoteLoading(false));
                networkResponseLog(uri, method, ex, ex, ex);
                reject(ex);
            });
    });
};

export const getAuthorizationToken = async ocToken => {
    const getAccessTokenFromOCTokenEndpoint = `${process.env.REACT_APP_WEB_API_URI}/pub/v1/cas/redeem/token`
    return request(
        getAccessTokenFromOCTokenEndpoint,
        {clientId: 'ma3', token: ocToken, redirectUri: `${window.location.origin}/`},
        'POST'
    );
};

export const refreshExpiredAuthToken = async refreshToken => {
    const refreshAuthorizationTokenEndpoint = `${process.env.REACT_APP_WEB_API_URI}/pub/v1/cas/refresh/token`;
    return request(
        refreshAuthorizationTokenEndpoint,
        {clientId: 'ma3', token: refreshToken},
        'POST'
    );
};

const networkRequestLog = (uri, method, requestArguments) => {
};

const networkResponseLog = (uri, method, data, status, error = null) => {
};

const checkResponseStatus = (response, ignoreLoggedOut) => {
    try {
        if (response.status === 400) {
            throw response;
        } else if (response.status === 401 && !ignoreLoggedOut) {
            if (store.applicationState.authorizationState.refresh_token) {
                console.log('refresh');
            }
            let redirectLocation = window.location;
            if(window.location == window.location.origin){
                redirectLocation = window.location.origin + "/my/albums%3Fts%3D" + new Date().getTime();
            }
            const authorizationLocation = `${process.env.REACT_APP_CAS_URL}&redirect_uri=${redirectLocation}`
            window.location = `${process.env.REACT_APP_CAS_URL}&redirect_uri=${window.location.origin}/my/albums%3Fts%3D` + new Date().getTime();
        } else if (response.status === 402) {
            store.dispatch(userSubscriptionExpired(true))
            if (document.location.indexOf("/my/cart") === -1) {
                applicationHistory.push('/my/account/storage-plan');
            }
        } else if (response.status === 403) {
            applicationHistory.push('/error/403');
        } else if (response.status === 404) {
            throw response;
        } else if (response.status === 405) {
            throw response;
        } else if (response.status >= 500 && response.status <= 599) {
            throw response;
        }
    }catch(promiseEx){
        throw promiseEx;
    }
};

const checkForTokenOrRedirect = ignoreLoggedOut => {
    let token;
    token = window.localStorage.getItem('authorization_token');
    if (!ignoreLoggedOut) {
        if (!token) {
            let redirectLocation = window.location;
            if(window.location == window.location.origin){
                redirectLocation = window.location.origin + "/my/albums%3Fts%3D" + new Date().getTime();
            }
            const authorizationLocation = `${process.env.REACT_APP_CAS_URL}&redirect_uri=${redirectLocation}`
            window.location = authorizationLocation;
        }
    }
    return token;
};





// WEBPACK FOOTER //
// ./src/common/request.js